import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'zerotoempty',
    standalone: true
})
export class ZeroPipe implements PipeTransform {

  transform(value: number, args?: any): any {
    return value===0 ? ''  : value.toString();
  }

}
